/**
 * OFFLINE QUEUE HOOK
 * 
 * React hook for monitoring and managing offline queue
 */

import { useState, useEffect } from 'react';
import { offlineQueue } from '../services/offlineQueue';

/**
 * Hook to monitor offline queue status
 */
export function useOfflineQueue() {
  const [status, setStatus] = useState(offlineQueue.getStatus());

  useEffect(() => {
    const updateStatus = () => {
      setStatus(offlineQueue.getStatus());
    };

    const unsubscribe = offlineQueue.subscribe(updateStatus);

    return unsubscribe;
  }, []);

  return {
    ...status,
    hasQueuedActions: status.queueSize > 0,
    sync: () => offlineQueue.sync(),
    clear: () => offlineQueue.clear(),
  };
}
